<template>
  <div>
    <b-container>
      <b-card  class="bk-color rounded border-0" >
        <b-card no-body class="transparent text-white align-items-center text-center border-0">
          <h5><i class="fa fa-filter mr-1 fa-2x filter-icon" v-b-modal.mobile-filters></i>{{storeDetail.data.retail_name}} {{storeDetail.data.retail_store_name}}</h5>
          <h6>Cod. Tiend: {{storeDetail.data.retail_store_code}}</h6>
        </b-card>
        <Loader v-if="loading"></Loader>
        <b-card v-else class="text-center transparent text-white border-0">
          <b-row>
            <b-col cols="6">
              Venta en unidades
              <h5>
                {{storeDetail.data.quantity_sold | number}}
              </h5>
            </b-col>
            <b-col cols="6">
              Stock en Unidades
              <h5>
                {{storeDetail.data.stock_quantity | number}}
              </h5>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="6">
              Venta en $
              <h5>{{storeDetail.data.real_sales_amount | money}}</h5>
            </b-col>
            <b-col cols="6">
              Stock en $ (PVP)
              <h5>{{storeDetail.data.real_stock_pvp_amount | money}}</h5>
            </b-col>
          </b-row>
        </b-card>
      </b-card>
      <b-card no-body class="border-0 m-0 text-center">
        <b-button class="mb-3 bk-color text-white m-0" style="width: 100%;"  v-if="!checkingIn || !checkedIn" @click="getPosition()">Check-In</b-button>
        <p v-else class="mt-3 mb-3" style="width: 100%;">Chequeando en tienda...</p>
        <b-button class="mb-3 bk-color text-white m-0" style="width: 100%;"  v-if="checkedIn" @click="getPosition()">Check-out</b-button>
      </b-card>
      <b-container fluid class="p-0">
        <b-row class="text-center text-dark">
          <b-col cols="6">
            <b-card @click="$router.push({name:'ProductDetail'})"
                    class="border-secondary h-100"
                    style="border-radius:25px">
              <h5>Ventas & <br> Stock</h5>
              <i style="color:#0d1052" class="fa fa-4x fa-table mt-3"></i>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
      <b-card class="border-0">
        <h4 v-if="activities">Actividades para esta tienda:</h4>
        <h6 v-else>No hay actividades para esta tienda</h6>
        <b-list-group>
          <b-list-group-item v-if="storeDetail.data.stock_quantity_wm > 0" @click="goTo('WmProductList', store_id)">
            <b-row>
              <b-col cols="10">
                Hay <strong>{{storeDetail.data.stock_quantity_wm}}</strong>
                unidades en Stock que no se están vendiendo.
                Entra al detalle y revisa los productos en la sala para verificarlos
              </b-col>
              <b-col cols="2">
                <i style="color:#0d1052" class="fa fa-chevron-right fa-2x mt-4" aria-hidden="true"></i>
              </b-col>
            </b-row>
          </b-list-group-item>

          <b-list-group-item v-if="storeDetail.data.new_stock_delta_quantity > 0" @click="$router.push({name:'NewStockProductList'})">
            <b-row>
              <b-col cols="10">
                Hay <strong>{{storeDetail.data.new_stock_delta_quantity}}</strong> unidades de stock ingresadas recientemente a
                la tienda. Revisa que estén bien exhibidas y que las unidades correspondan a la cantidad de unidades físicas
              </b-col>
              <b-col cols="2">
                <i style="color:#0d1052" class="fa fa-chevron-right fa-2x mt-4" aria-hidden="true"></i>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-container>
    <b-modal id="mobile-filters" ref="FilterModalRef" hide-footer title="Filtro de Productos">
      <MobileFilters></MobileFilters>
      <b-button block variant="primary"
                @click="filterModal">Filtrar</b-button>
    </b-modal>
  </div>
</template>


<script>
  import { storeDetail } from '../../expertoRetail/defaultPayloads/organismsMobile'
  import { sales, mobile } from '../../services/api/ExpertoRetail'
  import Loader from '@/expertoRetail/atoms/ExpertoRetailLoader'
  import { GeneralUtils } from '@/mixins/index'
  import MobileFilters from '@/expertoRetail/atoms/Mobile/MobileFilter'

  export default {
    name: 'mobile-store-detail',
    components: {
      Loader,
      MobileFilters
    },
    mixins: [GeneralUtils],
    data () {
      return {
        storeDetail: {
          data: {}
        },
        checkingIn: false,
        checkedIn: false,
        checkedOut: false,
        store_id: this.$store.state.mobile.store_id,
        loading: false,
        activities: false,
        userPosition: {
          userPosition: {}
        },
        videoElement: {},
        canvasElement: '',
        front: true,
        navError: ''
      }
    },
    created () {
      this.storeListRequest()
      if (this.userInfo.id === undefined) {
        this.$router.push('/')
      }
      this.$eventHub.$on('load-data-after-mobile-filter', this.storeListRequest)
    },
    beforeDestroy () {
      this.$eventHub.$off('load-data-after-mobile-filter')
    },
    computed: {
      vuexMobileFilters () {
        return this.$store.state.mobile.mobileFilters
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    mounted () {
    },
    methods: {
      storeListRequest () {
        let filterCopy = this.$_generalUtils_deepJsonCopy(this.vuexMobileFilters)
        storeDetail.parameters = {...storeDetail.parameters, ...filterCopy}
        storeDetail.parameters.store_filters.store_id = []
        storeDetail.parameters.store_filters.store_id.push(this.store_id.toString())
        this.loading = true
        return new Promise((resolve, reject) => {
          let vm = this
          sales.salesTwoRanges(storeDetail)
            .then(response => {
              if (response.data[0] === undefined) {
                alert('No existen datos para el filtro seleccionado')
              } else {
                vm.storeDetail.data = response.data[0]
              }
              resolve()
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => {
              vm.loading = false
            })
        })
      },
      filterModal () {
        this.$eventHub.$emit('mobile-product-filter')
        this.$refs.FilterModalRef.hide()
      },
      addFilter (id) {
        storeDetail.parameters.store_filters.store_id = []
        storeDetail.parameters.store_filters.store_id.push(id.toString())
        this.storeListRequest(storeDetail)
      },
      goTo (view) {
        this.$router.push({name: view})
      },
      showActivities () {
        let wmProduct = this.storeDetail.data.stock_quantity_wm
        let newStock = this.storeDetail.data.new_stock_delta_quantity
        if (wmProduct >= 1 || newStock >= 1) {
          this.activities = true
        }
      },
      checkIn (position) {
        let userPosition = {}
        let coordinate = '(' + position.coords.longitude + ', ' + position.coords.latitude + ')'
        let d = new Date()
        let n = d.getTime()
        userPosition.user_id = this.userInfo.id
        userPosition.store_id = this.store_id
        userPosition.coordinate = coordinate
        userPosition.latitude = position.coords.latitude
        userPosition.longitude = position.coords.longitude
        userPosition.checked_at = n
        this.userPosition.userPosition = userPosition
        this.userPostCheckIn(this.userPosition)
      },
      userPostCheckIn (parameters) {
        this.checkingIn = true
        return new Promise((resolve, reject) => {
          let vm = this
          mobile.userCheckIn(parameters)
            .then(() => {
              vm.checkedIn = true
              resolve(alert('Te has chequeado correctamente en tienda'))
            })
            .catch(error => {
              reject(error)
              alert('No se ha podido enviar tu posición. Verifica que el gps de tu dispositivo esté encendido y prueba nuevamente')
            })
            .finally(() => {
              vm.checkingIn = false
            })
        })
      },
      getPosition () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.checkIn)
        } else {
          alert('Tu dispositivo no puede enviar la posición')
        }
      },
      pushToform (form) {
        this.$router.push({name: form})
      }
    }
  }
</script>


<style scoped>
  .bk-color {
    /* Permalink - use to edit and share this graDient: http://colorzilla.com/gradient-editor/#1e5799+0,25146d+0,3f137c+73,50327a+98 */
    background: #0d1052; /* Old browsers */
  }
  .transparent {
    background-color: transparent;
  }
  .filter-icon {
    position: absolute;
    top: 1px;
    right: 1px;
  }
  #video-container {
    margin: 2em auto 0;
    width: 500px;
    padding: 2em;
    background: white;
    -webkit-box-shadow: 0 1px 10px #D9D9D9;
    -moz-box-shadow: 0 1px 10px #D9D9D9;
    -ms-box-shadow: 0 1px 10px #D9D9D9;
    -o-box-shadow: 0 1px 10px #D9D9D9;
    box-shadow: 0 1px 10px #D9D9D9;
  }
</style>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/ExpertoRetailMobileStoreDetail.vue